import type { DeleteKidsRemoveRequest, DeleteKidsRemoveResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const deleteKidsRemove = sendRequest<DeleteKidsRemoveRequest, DeleteKidsRemoveResponse>({
  url: '/kids/remove',
  method: 'delete',
});
